import { DateRangePickerProps } from '@cloudscape-design/components/date-range-picker';

import { formatDate } from './date';

const MAX_RANGE_DAYS = 365;

export const DATE_PRESETS: { label: string; days: number }[] = [
  { label: '10d', days: 10 },
  { label: '30d', days: 30 },
  { label: '60d', days: 60 },
  { label: '90d', days: 90 },
];

export const DEFAULT_PRESET_DAYS = 10;

export function presetToRange(days: number): DateRangePickerProps.AbsoluteValue {
  const end = new Date();
  const start = new Date(end);
  start.setDate(start.getDate() - days);
  return { type: 'absolute', startDate: formatDate(start), endDate: formatDate(end) };
}

export const DEFAULT_RANGE = presetToRange(DEFAULT_PRESET_DAYS);

export function toDateStrings(value: DateRangePickerProps.Value | null): {
  startDate?: string;
  endDate?: string;
} {
  if (!value) return {};
  if (value.type === 'absolute') {
    return {
      startDate: value.startDate.slice(0, 10),
      endDate: value.endDate.slice(0, 10),
    };
  }
  const end = new Date();
  const start = new Date(end);
  start.setDate(start.getDate() - value.amount);
  return { startDate: formatDate(start), endDate: formatDate(end) };
}

export const isValidRange: DateRangePickerProps.ValidationFunction = (value) => {
  if (!value || value.type !== 'absolute' || !value.startDate || !value.endDate) {
    return { valid: false, errorMessage: 'Select a start and end date.' };
  }
  const start = new Date(value.startDate).getTime();
  const end = new Date(value.endDate).getTime();
  if (end < start) {
    return { valid: false, errorMessage: 'End date must be after start date.' };
  }
  if ((end - start) / 86400000 > MAX_RANGE_DAYS) {
    return { valid: false, errorMessage: 'Date range cannot exceed 1 year.' };
  }
  return { valid: true };
};

export const DATE_RANGE_I18N: DateRangePickerProps.I18nStrings = {
  todayAriaLabel: 'Today',
  nextMonthAriaLabel: 'Next month',
  previousMonthAriaLabel: 'Previous month',
  startDateLabel: 'Start date',
  endDateLabel: 'End date',
  clearButtonLabel: 'Clear',
  cancelButtonLabel: 'Cancel',
  applyButtonLabel: 'Apply',
  relativeModeTitle: 'Relative range',
  absoluteModeTitle: 'Absolute range',
  dateTimeConstraintText: 'Range must be within 1 year.',
};
